module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('shared-product-provide', {
    attrs: {
      "product": _vm.product,
      "fromModule": _vm.fromModule,
      "toModule": _vm.toModule
    }
  }, [_c('loader', {
    attrs: {
      "loading": _vm.loadingAttributes || _vm.loadingProductTypes
    }
  }), _vm._v(" "), _c('form-group', {
    attrs: {
      "label": _vm.$t('brand.label'),
      "columns": 3,
      "error": _vm.getError('brand', _vm.product.productId),
      "required": true
    }
  }, [_c('multiselect', {
    attrs: {
      "options": _vm.brands,
      "selectLabel": "",
      "selectedLabel": "",
      "placeholder": "Buscar Marca"
    },
    model: {
      value: (_vm.product.brand),
      callback: function($$v) {
        _vm.$set(_vm.product, "brand", $$v)
      },
      expression: "product.brand"
    }
  })], 1), _vm._v(" "), _c('form-group', {
    attrs: {
      "label": _vm.$t('departments.label'),
      "columns": 3,
      "error": _vm.getError('department', _vm.product.productId),
      "required": true
    }
  }, [_c('multiselect', {
    attrs: {
      "options": _vm.departments,
      "selectLabel": "",
      "selectedLabel": "",
      "placeholder": "Escolha",
      "group-label": "channel",
      "group-values": "departments",
      "track-by": "value",
      "label": "label"
    },
    model: {
      value: (_vm.department),
      callback: function($$v) {
        _vm.department = $$v
      },
      expression: "department"
    }
  })], 1), _vm._v(" "), (_vm.productTypes.length) ? _c('form-group', {
    attrs: {
      "label": _vm.$t('productTypes.label'),
      "columns": 3,
      "error": _vm.getError('productType', _vm.product.productId),
      "required": true
    }
  }, [_c('multiselect', {
    attrs: {
      "options": _vm.productTypes,
      "selectLabel": "",
      "selectedLabel": "",
      "placeholder": "Escolha"
    },
    model: {
      value: (_vm.productType),
      callback: function($$v) {
        _vm.productType = $$v
      },
      expression: "productType"
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.attributes.length) ? _c('div', {
    staticClass: "l-col-12@md"
  }, [_c('div', {
    staticClass: "divider"
  }, [_c('span', [_vm._v("Atributos")])])]) : _vm._e(), _vm._v(" "), _vm._l((_vm.attributes), function(attribute, index) {
    return _c('form-group', {
      key: attribute.code,
      attrs: {
        "label": attribute.name,
        "columns": 3,
        "error": _vm.getError(attribute.code, _vm.product.productId),
        "required": attribute.required
      }
    }, [(attribute.typeSelection === 'TIPO_SELECAO_LISTA') ? _c('select', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (attribute.value),
        expression: "attribute.value"
      }],
      staticClass: "form-select",
      attrs: {
        "disabled": _vm.disabledInputs()
      },
      on: {
        "change": function($event) {
          var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
            return o.selected
          }).map(function(o) {
            var val = "_value" in o ? o._value : o.value;
            return val
          });
          _vm.$set(attribute, "value", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
        }
      }
    }, [_c('option', {
      attrs: {
        "value": "undefined"
      }
    }, [_vm._v(_vm._s(_vm.$t('choose.label')))]), _vm._v(" "), _vm._l((attribute.values), function(option) {
      return _c('option', {
        domProps: {
          "value": option
        }
      }, [_vm._v(_vm._s(option))])
    })], 2) : (attribute.typeSelection === 'TIPO_SELECAO_COMBO') ? _c('multiselect', {
      attrs: {
        "options": attribute.values,
        "multiple": true,
        "selectLabel": "Clique",
        "selectedLabel": "Selecionado",
        "placeholder": "Selecione a opção"
      },
      model: {
        value: (attribute.value),
        callback: function($$v) {
          _vm.$set(attribute, "value", $$v)
        },
        expression: "attribute.value"
      }
    }) : _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (attribute.value),
        expression: "attribute.value"
      }],
      staticClass: "form-input",
      attrs: {
        "type": "text",
        "disabled": _vm.disabledInputs()
      },
      domProps: {
        "value": (attribute.value)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(attribute, "value", $event.target.value)
        }
      }
    })], 1)
  })], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-3f59f0a3","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/marketplace/netshoes/provide/Product.vue
// module id = 3081
// module chunks = 0